import { render, staticRenderFns } from "./margeForm.vue?vue&type=template&id=528c7c1e"
import script from "./margeForm.vue?vue&type=script&lang=js"
export * from "./margeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports